import { SearchDropdownProps } from "@/features/shop/types/searchBar.types";

export const SearchDropdown = ({
  results,
  onSelectResult,
  isOpen,
}: SearchDropdownProps) => {
  if (!isOpen || results.length === 0) {
    return null;
  }

  return (
    <div className="absolute top-full left-0 right-0 z-50 mt-2 overflow-hidden bg-white border-0 shadow-xl rounded-xl dark:bg-gray-800 animate-fade-in">
      <ul className="max-h-96 overflow-y-auto scrollbar-thin">
        {results.map((result, index) => (
          <li key={result.id}>
            <button
              type="button"
              onClick={() => onSelectResult(result)}
              className="w-full px-6 py-4 text-left transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-700/50 focus:outline-none focus:bg-gray-50 dark:focus:bg-gray-700/50"
            >
              <div className="flex flex-col gap-1">
                <span className="text-base font-semibold text-gray-900 dark:text-white">
                  {result.name}
                </span>
                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-gray-500 dark:text-gray-400">
                    {result.category}
                  </span>
                  <span className="text-xs text-gray-400 dark:text-gray-500">
                    •
                  </span>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {result.description}
                  </span>
                </div>
              </div>
            </button>
            {index < results.length - 1 && (
              <div className="h-px mx-4 bg-gray-100 dark:bg-gray-700/50" />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
